//Types
export const Types = {
  GET_EXPRESSIONS: "GET_EXPRESSIONS",
  GET_ALL_EXPRESSIONS: "GET_ALL_EXPRESSIONS",
  GET_EXPRESSION: "GET_EXPRESSION",
  CREATE_EXPRESSIONS: "CREATE_EXPRESSIONS",
  UPDATE_EXPRESSIONS: "UPDATE_EXPRESSIONS",
  DELETE_EXPRESSIONS: "DELETE_EXPRESSIONS",
  SET_LOADING: "SET_LOADING_EXPRESSIONS",
}

//Reducer
const initialState = {
  expressions: null,
  expression: null,
  allExpressions: null,

  loading: false,
}

const Expressions = (state = initialState, action) => {
  switch (action.type) {
    case Types.GET_EXPRESSIONS:
      return {
        ...state,
        expressions: action.payload,
        loading: false,
      }
      case Types.GET_ALL_EXPRESSIONS:
      return {
        ...state,
        allExpressions: action.payload,
        loading: false,
      }
    case Types.GET_EXPRESSION:
      return {
        ...state,
        expression: action.payload,
        loading: false,
      }
    case Types.CREATE_EXPRESSIONS:
      return {
        ...state,
        expression: action.payload,
        loading: false,
      }
    case Types.UPDATE_EXPRESSIONS:
      return {
        ...state,
        expression: action.payload,
        loading: false,
      }
    case Types.DELETE_EXPRESSIONS:
      return {
        ...state,
        loading: false,
      }
    case Types.SET_LOADING:
      return {
        ...state,
        loading: true,
      }

    default:
      return state;
  }
}

export default Expressions;
